/**
 * DED-1535: Supplier Register Page
 * 
 * This page displays only suppliers (componentType === 'Supplier') from the asset register.
 * It reuses the AssetRegister component with registerType="Supplier".
 */
import React from 'react';
import AssetRegister from '../asset-register';

const SupplierRegister: React.FC<{ basePath?: string; isReadOnly?: boolean }> = ({ 
  basePath = '/supplierdetail', 
  isReadOnly = false 
}) => {
  return (
    <AssetRegister 
      basePath={basePath} 
      isReadOnly={isReadOnly} 
      registerType="Supplier" 
    />
  );
};

export default SupplierRegister;
